import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function TermsOfService() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Terms of Service</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-gray-600 mb-6">
              <strong>Last Updated:</strong> January 4, 2026
            </p>
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Acceptance of Terms</h2>
                <p className="text-gray-600">
                  By accessing and using BoardVoyage, you accept and agree to be bound by these Terms of Service.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">User Accounts</h2>
                <p className="text-gray-600">
                  You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Prohibited Conduct</h2>
                <p className="text-gray-600">
                  Users must not engage in harassment, spam, or any activity that violates our Community Guidelines or applicable laws.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Limitation of Liability</h2>
                <p className="text-gray-600">
                  BoardVoyage provides the platform "as is" and makes no warranties regarding the availability, accuracy, or reliability of the service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TermsOfService;
